import React from 'react';

interface BillingRecalculatingBadgeProps {
  isVisible: boolean;
}

export const BillingRecalculatingBadge: React.FC<BillingRecalculatingBadgeProps> = props => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <span className="rounded-full bg-amber-50 px-2 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-500">
      Recalculating
    </span>
  );
};
